import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';
import isMobile from 'ismobilejs';

import MemberPhotoList from 'components/list/MemberPhotoList';

import {t} from 'l10n'

import paths from 'paths';

import 'sass/profile/albumProfile.scss';

class ProfileAlbumBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let {memberPhotos, sectionNumber, match} = this.props,
            {list, totalCount} = memberPhotos;

        return (
            <aside className={'album-main ' + ((sectionNumber % 2)==0?'even':'odd')}>
                <div className="content">
                    <div className="heading">
                        <h2>{t('Album')} <em>{totalCount}</em></h2>
                        {(list.length && !isMobile.any) ? <Link to={paths.profileAlbum.toPath({nick: match.params.nick})} className="list-items">{t('See all photos')}</Link> : null}
                    </div>

                    <MemberPhotoList
                        memberPhotos={list}
                        xxlCheck
                        doubleRow
                    />

                    {(list.length && isMobile.any) ? <Link to={paths.profileAlbum.toPath({nick: match.params.nick})} className="get-all-photo">{t('See all photos')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default ProfileAlbumBlock;


// WEBPACK FOOTER //
// ./src/components/profile/ProfileAlbumBlock.js